import { createFileRoute } from '@tanstack/react-router';
import { tw } from '@/lib/tailwind';
import { useBoundStore } from '@/store';
import type { StagingRegion } from '@/constants/regions';
import { STAGING_REGIONS } from '@/constants/regions';

const STAGING_PULSE_URL = 'https://dev-v2-03.staging.cloud.chattermill.xyz/login?source=alchemer&link_target=self';
const PROD_PULSE_URL = 'https://app.chattermill.com/login?source=alchemer&link_target=self';

export const Route = createFileRoute('/pulse/')({
  component: RouteComponent,
});

function RouteComponent() {
  const selectedRegion = useBoundStore((state) => state.selectedRegion);
  const src = STAGING_REGIONS.includes(selectedRegion as StagingRegion) ? STAGING_PULSE_URL : PROD_PULSE_URL;

  return (
    <div>
      <iframe
        className={tw('h-screen w-full')}
        src={src}
        title="Pulse"
      />
    </div>
  );
}
